import OrderIcon from '@mui/icons-material/AttachMoney';
import SubjectList from './SubjectList';
export default {
    list: SubjectList,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
